/**
 * Parse EPG shift hours from a channel display name, e.g. "Channel +2", "Polsat +1", "News -1".
 * Matches +N / -N at the end of the name.
 */
export function parseShiftFromName(name: string | null | undefined): number | null {
  if (name == null) return null;
  const s = String(name).trim();
  if (!s) return null;
  const m = s.match(/([+-])(\d+)\s*$/);
  if (!m) return null;
  const n = Number.parseInt(m[2], 10);
  if (!Number.isFinite(n) || n === 0) return null;
  const signed = m[1] === '-' ? -n : n;
  return Math.max(-36, Math.min(36, signed));
}

export function catchupDaysFromChannel(ch: {
  catchup_days?: number | null;
  tv_archive_duration?: number | null;
} | null | undefined): number {
  if (!ch) return 0;
  const d = Number(ch.catchup_days);
  if (Number.isFinite(d) && d >= 0) return Math.floor(d);
  const arch = Number(ch.tv_archive_duration);
  if (Number.isFinite(arch) && arch > 0) return Math.floor(arch);
  return 0;
}
